// Central place for the shared application schema that hosts common tables/views
// (users, user permissions, user_tenants, and other cross-schema metadata).
export const SPECIAL_SCHEMA = 'vaultbi' as const

export const SPECIAL_TABLES = {
  users: 'users',
  userPermissions: 'user_permissions',
  userTenants: 'user_tenants',
  tenantsIntegrations: 'tenants_integrations',
} as const
